var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 11.0659V15.9393H23.7292V2.87759C28.4042 3.16093 31.1667 6.17843 31.1667 11.0659Z",
    fill: "#3C3D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 18.0625V22.9358C31.1667 27.8233 28.4042 30.8408 23.7292 31.1242V18.0625H31.1667Z",
    fill: "#3C3D3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2708 18.0625V31.1242C5.59581 30.8408 2.83331 27.8233 2.83331 22.9358V18.0625H10.2708Z",
    fill: "#3C3D3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2708 2.87759V15.9393H2.83331V11.0659C2.83331 6.17843 5.59581 3.16093 10.2708 2.87759Z",
    fill: "#3C3D3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6041 2.83334H12.3958V15.9375H21.6041V2.83334Z",
    fill: "#3C3D3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6041 18.0625H12.3958V31.1667H21.6041V18.0625Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid8);
export default __webpack_public_path__ + "static/media/grid-8.c97d46f7fe04621b05e881bc85831b14.svg";
export { ForwardRef as ReactComponent };